module.exports = __webpack_public_path__ + "img/PRCA1_Myofibroblasts.f95f17a8.png";